import React from "react";

import { Box } from "@mui/material";
import { Grid } from "@material-ui/core";

import { CheckedRadioGroup } from "../../../../shared/components/commonComponents/CheckedRadioGroup";
import { Button } from "../../../../shared/widgets";

function CityProfileConfig(props) {
  const {
    configData, onChangeHandler, handleOnClick, initial,
  } = props;

  const cityProfileData = [
    {
      label: "Contract Type",
      option: [
        { label: "Agency Level", value: "agencyLevel" },
        { label: "Bus Level", value: "busLevel" },
      ],
      defaultValue: configData.contractType,
      name: "contractType",
    },
    // {
    //   label: 'Recharge Amount Responsibility',
    //   option: [
    //     { label: 'Chalo', value: 'chalo' },
    //     { label: 'Operator', value: 'operator' },
    //   ],
    //   defaultValue: configData.rechargeAmountResponsibility,
    //   name: 'rechargeAmountResponsibility',
    // },
    {
      label: "Collection Handled By",
      option: [
        { label: "Chalo", value: "chalo" },
        { label: "Operator", value: "operator" },
      ],
      defaultValue: configData.collectionHandledBy,
      name: "collectionHandledBy",
    },
    {
      label: "Pass Issued",
      option: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
      defaultValue: configData.passIssued,
      name: "passIssued",
    },
  ];

  return (
    <Box padding={3}>
      <Grid container direction="column" spacing={4}>
        {cityProfileData.map((item) => (
          <Grid key={item.name} container item alignItems="flex-end">
            <Grid item xs={12} sm={6} md={4}>
              <Box sx={{ fontWeight: "bold" }}>{item.label}</Box>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <CheckedRadioGroup
                options={item.option}
                onChangeHandler={onChangeHandler}
                defaultValue={item.defaultValue}
                name={item.name}
              />
            </Grid>
          </Grid>
        ))}

        {/* <Grid container item alignItems="flex-end">
          <Grid item xs={12} sm={6} md={4}>
            <Box sx={{ fontWeight: 'bold' }}>Revenue Recognition Type</Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2}>
            <CommonDropdown
              required
              options={[
                {
                  label: 'Sales Data',
                  value: 'salesData',
                },
                {
                  label: 'AFCS Tickets (Consumption Data) ',
                  value: 'afcsData',
                },
              ]}
              onChangeHandler={onChangeHandler}
              selectedValue={configData.passRevenueRecognition}
              inputLabel={'Select'}
              name={'passRevenueRecognition'}
            />
          </Grid>
        </Grid>

        {configData.passRevenueRecognition === 'salesData' && (
          <Grid container item alignItems="flex-end">
            <Grid item xs={12} sm={6} md={4}>
              <Box sx={{ fontWeight: 'bold' }}>Pass Revenue Flag</Box>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <CheckedRadioGroup
                options={[
                  { label: 'Automatic', value: 'automatic' },
                  { label: 'Manual', value: 'manual' },
                ]}
                defaultValue={configData.passRevenueFlag}
                onChangeHandler={onChangeHandler}
                name="passRevenueFlag"
              />
            </Grid>
          </Grid>
        )} */}

        <Grid container item>
          <Grid className="config-form-button" item>
            <Button
              buttonText="Update Configuration"
              onClick={() => handleOnClick("agencyProfile")}
              disable={
                JSON.stringify(configData) === JSON.stringify(initial)
                // !configData?.rechargeAmountResponsibility ||
                // !(configData?.passRevenueRecognition === 'salesData'
                //   ? configData?.passRevenueFlag
                //   : true) ||
                // !configData?.passRevenueRecognition
              }
            />
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default CityProfileConfig;
